var _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJais({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "circle-clip"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 108,
    r: 108
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#circle-clip)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C71.28 0 142.56 0 216 0 C216 71.28 216 142.56 216 216 C144.72 216 73.44 216 0 216 C0 144.72 0 73.44 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(0,0)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.9) translate(12 12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C33.33 0 66.66 0 101 0 C101.0825 12.58125 101.165 25.1625 101.25 38.125 C101.28641602 42.06969238 101.32283203 46.01438477 101.36035156 50.07861328 C101.37841797 54.96655273 101.37841797 54.96655273 101.3817749 57.26852417 C101.38784122 58.84628844 101.40174781 60.42403643 101.42230225 62.00167847 C101.59235024 75.76444589 100.05380795 88.102497 92.8125 100.1875 C92.42304199 100.85330078 92.03358398 101.51910156 91.63232422 102.20507812 C83.91123093 115.08288068 74.04459161 125.1848641 60 131 C59.18917969 131.37125 58.37835938 131.7425 57.54296875 132.125 C42.63330055 138.13057265 20.54947991 136.54124908 5.6875 130.875 C-12.006042 122.70135288 -23.05615096 108.69876032 -30.03515625 90.76953125 C-32.79331763 82.85237975 -33 76.72040639 -33 68 C-22.11 68 -11.22 68 0 68 C0.99 71.3 1.98 74.6 3 78 C4.39321614 81.19837992 6.10141821 84.07574759 8 87 C8.40734375 87.6290625 8.8146875 88.258125 9.234375 88.90625 C13.85488957 95.10317542 20.56231328 99.13990263 28.21337891 100.35009766 C38.81832368 101.38851216 48.19438437 100.53227042 57 94 C62.41471009 89.25671396 66.59966289 82.2355013 67.15821838 74.93086243 C67.17376266 74.1381041 67.18930695 73.34534576 67.20532227 72.52856445 C67.22550415 71.61530396 67.24568604 70.70204346 67.26647949 69.7611084 C67.28295532 68.80482544 67.29943115 67.84854248 67.31640625 66.86328125 C67.33505737 65.98168335 67.3537085 65.10008545 67.3729248 64.19177246 C67.44121944 60.89878352 67.50137012 57.60562974 67.5625 54.3125 C67.706875 46.949375 67.85125 39.58625 68 32 C45.56 32 23.12 32 0 32 C0 21.44 0 10.88 0 0 Z ",
    fill: "#645FF1",
    transform: "translate(58,57)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C10.89 0 21.78 0 33 0 C33 10.89 33 21.78 33 33 C22.11 33 11.22 33 0 33 C0 22.11 0 11.22 0 0 Z ",
    fill: "#070741",
    transform: "translate(159,24)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C10.89 0 21.78 0 33 0 C33 10.89 33 21.78 33 33 C22.11 33 11.22 33 0 33 C0 22.11 0 11.22 0 0 Z M2 1 C2 10.9 2 20.8 2 31 C11.57 31 21.14 31 31 31 C31 21.1 31 11.2 31 1 C21.43 1 11.86 1 2 1 Z ",
    fill: "#2A2A5A",
    transform: "translate(159,24)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJais);
export default __webpack_public_path__ + "static/media/jais.72ecb61080885bfa7386520df627c12b.svg";
export { ForwardRef as ReactComponent };